class ScrollListener {
    constructor(element) {
        this.element = element;
        this.isUserScrolling = false; // 是否是用户触发的滚动

        this.startX = 0; // 滑动起始 X 坐标

        this.startY = 0; // 滑动起始 Y 坐标

        this.isSliding = false;

        this.callback = null;

        this.timer = null;

        // 监听滚动事件
        this.element.addEventListener("scroll", this.handleScroll.bind(this));

        // 监听用户触发的滚动（PC 端：鼠标滚轮，移动端：触摸滑动）
        this.element.addEventListener("wheel", this.handleWheel.bind(this)); // PC 端
        this.element.addEventListener("touchstart", this.handleTouchStart.bind(this)); // 移动端
        this.element.addEventListener("touchmove", this.handleTouchMove.bind(this)); // 移动端
        this.element.addEventListener("touchend", this.handleTouchEnd.bind(this)); // 移动端
    }

    // 处理滚动事件
    handleScroll() {

        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.isSliding = false;
            this.isUserScrolling = false;
        }, 60);

        this.executeCallback()
    }

    handleWheel(ev) {
        // 判断滑块在底部或是顶部不触发
        if (ev.deltaY < 0) {
            // 向上滚动
            if (this.element.scrollTop === 0) {
                return;
            }
        } else {
            // 向下滚动
            const epsilon = 1;
            if (Math.abs(this.element.scrollTop + this.element.clientHeight - this.element.scrollHeight) <= epsilon) {
                this.isSliding = false;
                this.isUserScrolling = false;
                this.executeCallback()
                return;
            }
        }

        this.isSliding = true;
        this.isUserScrolling = true;
    }

    // 处理用户触发的滚动
    handleTouchStart(ev) {
        this.isSliding = true;
        this.startX = ev.touches[0].clientX;
        this.startY = ev.touches[0].clientY;
    }

    handleTouchMove(ev) {
        if (!this.isSliding) return;

        const currentX = ev.touches[0].clientX;
        const currentY = ev.touches[0].clientY;
        this.calculateDirection(currentX, currentY);
    }

    handleTouchEnd() {
        this.isSliding = false;
        this.isUserScrolling = false
    }

    calculateDirection(currentX, currentY) {
        const deltaX = Math.abs(currentX - this.startX);
        const deltaY = Math.abs(currentY - this.startY);

        if (deltaX > deltaY && deltaX > 10) {
            this.isUserScrolling = false;
        } else if (deltaY > deltaX && deltaY > 10) {
            this.direction = "vertical"; // 垂直滑动
            this.isUserScrolling = true;
            this.executeCallback()
        }

    }

    checkUserScroll(fn) {
        fn && (this.callback = fn)
    }

    executeCallback() {
        this.callback && this.callback(this.isUserScrolling)
    }
}

export default ScrollListener;
